import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../../../components/input/textinput/TextInput';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import styles from './SelectYearFormType.styles';
import { getFormsList, getStateNamesList, getStatePayrollFormsList } from '../CreateFormSaga';
import { componentKey, setIsIncorrectFormRecordId, setIsYearFormTypeSelected, setToCreateFormData, updateFormsPreLoadedData, setSelect1099Forms, setSelectedStateName, setStatePayrollFormsList } from '../CreateFormSlice';
import './directcss/CreateForm.scss';
import FooterWImageAndActionButtons from '../../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import Loadable from '../../../../components/loadable/Loadable';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP, CREATE_FORM_BUTTONS_FLAGS } from '../constants';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import CardWTopLeftIcon from '../../../../components/card/CardWTopLeftIcon/CardWTopLeftIcon';
import RecommendForms from '../../../components/recommendform/RecommendForm';
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import { QUERY_PARAMS } from '../../constants';
import { FEATURE_FLAG } from '../../../../featureFlags';

export default function SelectYearFormType() {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedYearForms, setSelectedYearForms] = useState([]);
    const [displayForms, setDisplayForms] = useState([]);
    const [isErrorInQueryParams, setIsErrorInQueryParams] = useState(false);
    const [showFormRecommendation, setShowFormRecommendation] = useState(false)
    const [initialOnMountRunCompleted, setInitialOnMountRunCompleted] = useState(false)

    const dispatch = useDispatch();
    const { loadingState, formsList, toCreateFormData, isIncorrectFormRecordId, isSelect1099Forms, stateNamesList, selectedStateName, statePayrollFormsList } = useSelector((state) => state[componentKey]);
    const [queryParams, setQueryParams] = useTxSearchParams();

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    useEffect(() => {
        const formNameFromUrl = queryParams.get(QUERY_PARAMS.FORM_NAME);
        if (formNameFromUrl && formNameFromUrl.includes(QUERY_PARAMS.PAYROLL)) {
            if(!FEATURE_FLAG.SHOW_STATE_PAYROLL){
                setIsErrorInQueryParams(true);
                return
            }
            const stateNameFromUrl = queryParams.get(QUERY_PARAMS.STATENAME);
            dispatch(getStateNamesList({stateNameFromUrl: stateNameFromUrl}));
            dispatch(setSelect1099Forms(false));
        }else{
            dispatch(setSelect1099Forms(true));
            dispatch(getFormsList());
        }
        setInitialOnMountRunCompleted(true)
    }, []);

    useEffect(() => {
        if(initialOnMountRunCompleted){
            if(isSelect1099Forms){
                if(!formsList?.Forms){
                    dispatch(getFormsList());
                }
            }else{
                if(!stateNamesList?.Years){
                    dispatch(getStateNamesList({stateNameFromUrl: null}));
                }
            }
        }
    }, [isSelect1099Forms])

    useEffect(() => {
        setDisplayForms((forms) => {
            const searchedFormList = selectedYearForms.filter((form) => {
                if (form.FormLabel.toLowerCase().includes(searchTerm.toLowerCase())) {
                    return form
                }
            });
            if (searchedFormList) {
                return searchedFormList;
            } else {
                return [];
            }
        })
    }, [searchTerm]);

    useEffect(() => {
        if (isIncorrectFormRecordId) {
            setIsErrorInQueryParams(true);
            dispatch(setIsIncorrectFormRecordId(null));
        }
    }, [isIncorrectFormRecordId]);

    useEffect(() => {
        if (((formsList?.Forms && formsList?.Forms.length > 0) || (statePayrollFormsList && statePayrollFormsList?.length > 0)) && !isIncorrectFormRecordId && !isErrorInQueryParams) {
            const urlFormName = queryParams.get(QUERY_PARAMS.FORM_NAME);
            const urlYear = queryParams.get(QUERY_PARAMS.YEAR);
            const urlFormRecordId = queryParams.get(QUERY_PARAMS.FORM_RECORD_ID);
            
            if (urlFormName && urlYear) {
                let formFromUrl = null;
                if (isSelect1099Forms) {
                    formFromUrl = formsList?.Forms && formsList.Forms.filter((form) => {
                        return form?.FormId === urlFormName && form.Year.includes(parseInt(urlYear));
                    });
                } else {
                    formFromUrl = statePayrollFormsList && statePayrollFormsList.filter((form) => {
                        return form?.FormId === urlFormName && form.Year.includes(parseInt(urlYear));
                    });
                }

                if (formFromUrl.length > 0) {
                    let toCreateFormDataTempObj = {
                        selectedYear: urlYear,
                        selectedForm: formFromUrl[0],
                    }
                    if (urlFormRecordId) {
                        toCreateFormDataTempObj = {
                            ...toCreateFormDataTempObj,
                            FormRecordId: urlFormRecordId,
                            isFormEditMode: true,
                        }
                    }
                    dispatch(setToCreateFormData({ ...toCreateFormDataTempObj }));
                    dispatch(setIsYearFormTypeSelected(true));
                } else {
                    setIsErrorInQueryParams(true);
                }
            }
                      
        }
    }, [formsList, statePayrollFormsList]);

    useEffect(() => {
        const formListOfYearTemp = formsList?.Forms && formsList.Forms.filter((forms) => {
            return forms.Year.includes(toCreateFormData.selectedYear);
        });

        setSelectedYearForms(formListOfYearTemp ?? []);
        setDisplayForms(formListOfYearTemp ?? []);
        setSearchTerm("");
        if (toCreateFormData.selectedYear) {
            queryParams.set("Year", toCreateFormData.selectedYear);
            setQueryParams(queryParams);
        }
    }, [toCreateFormData.selectedYear]);

    useEffect(() => {
        if (toCreateFormData?.selectedForm?.FormId) {
            queryParams.set("FormName", toCreateFormData?.selectedForm?.FormId);
            setQueryParams(queryParams);
        }
    }, [toCreateFormData.selectedForm])

    const handleFormSelect = (form) => {
        dispatch(setToCreateFormData({ selectedForm: form }));

        const availableYears = form?.Year.map((item) => {
            return {
                label: item.toString(),
                value: item,
            }
        });
        dispatch(updateFormsPreLoadedData({ selectedFormYears: availableYears }));
    }

    const handleFormsBtnClick = (source, isForm) => {
        
        dispatch(setToCreateFormData({ selectedForm: null }));
                                    
        queryParams.delete(QUERY_PARAMS.FORM_NAME);
        if(isForm){
            queryParams.delete(QUERY_PARAMS.STATENAME);
        }
        queryParams.delete(QUERY_PARAMS.FORM_RECORD_ID);
        setQueryParams(queryParams);

        if (source === CREATE_FORM_BUTTONS_FLAGS.FOR1099_FORMS) {
            dispatch(setSelect1099Forms(true));
            dispatch(setSelectedStateName({ label: "", value: "" }));
        }
        else {
            dispatch(setSelect1099Forms(false));
        }
    }    

    useEffect(() => {
        if(selectedStateName.label !== ""){
            dispatch(getStatePayrollFormsList(selectedStateName.label))
        }else{
            dispatch(setStatePayrollFormsList([]))
        }
    }, [selectedStateName])

    const handleStatePayrollFormSelect = (form) => {
        dispatch(setToCreateFormData({ selectedForm: form }));

        const availableYears = form?.Year.map((item) => {
            return {
                label: item.toString(),
                value: item,
            }
        });
        dispatch(updateFormsPreLoadedData({ selectedFormYears: availableYears }));
    }

    return <>

        {isErrorInQueryParams ? <div>
            <p>The form that you are looking for does not exist.</p>
        </div>
            :
            <Loadable currentState={loadingState.state} loadingStates={[CREATE_FORMS_LOADING_STATES.SELECT_YEAR_LOADING]} messageMap={CREATE_FORM_STATES_MESSAGE_MAP} isNewLoadable={true}>
                <div style={styles.createFormContainer}>
                    <div style={styles.bodyContainer}>
                        {
                            FEATURE_FLAG.SHOW_STATE_PAYROLL && <>
                            <div style={styles.headerRow}>
                                <Heading type={HEADING.H1}>
                                    Which form would you like to efile?
                                </Heading>
                            </div>
                            <div style={styles.btn1099StatepayrollRow}>
                                <Button
                                    style={{ ...styles.formsTypeTabsBox, ...(isSelect1099Forms) ? styles.selectedYearBox : "" }}
                                    onClickCb={() => {
                                        handleFormsBtnClick(CREATE_FORM_BUTTONS_FLAGS.FOR1099_FORMS, true);
                                    }}
                                >1099 Forms</Button>
                                <Button
                                    style={{ ...styles.formsTypeTabsBox, ...(!isSelect1099Forms) ? styles.selectedYearBox : "" }}
                                    onClickCb={() => {
                                        handleFormsBtnClick(CREATE_FORM_BUTTONS_FLAGS.FORSTATEPAYROLL_FORMS, true);
                                    }}
                                >State Payroll Forms</Button>
                                
                            </div>
                            </>
                        }
                        
                        {isSelect1099Forms &&
                            <>
                                <div>Select Tax Year</div>
                                <div style={styles.yearSelectionRowContainer}>
                                    <div style={styles.yearSelectionRow}>
                                        {
                                            formsList?.Years && formsList.Years.map((formYear) => {
                                                return <div onClick={() => dispatch(setToCreateFormData({ selectedYear: formYear }))} style={{ ...styles.yearBox, ...(toCreateFormData.selectedYear === formYear) ? styles.selectedYearBox : "" }} className={(toCreateFormData.selectedYear === formYear) ? "selectedYearBox" : ""} >
                                                    {formYear}
                                                </div>
                                            })
                                        }
                                    </div>
                                    <div style={styles.recommendCardContainer}>
                                        {toCreateFormData.selectedYear != null ? <CardWTopLeftIcon
                                            topLeftIcon={{ icon: VEC_ICON_NAME.INFO_ICON, title: "" }}
                                            title="Need help in finding a form ?"
                                            linkButtonProps={{ label: "Tax form recommendation engine", onClickCb: () => setShowFormRecommendation(true) }}
                                            subText="1099 forms can be confusing at times. However, we can provide the best recommendations based on your needs"
                                        /> : null}
                                    </div>
                                </div>
                                <div style={styles.searchRow}>
                                    <TextInput
                                        name="searchForm"
                                        type="text"
                                        value={searchTerm}
                                        placeHolder='Search by form name...'
                                        onChangeCb={handleSearchChange}
                                        suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                                    />
                                </div>
                                <div style={styles.formSelectionRow}>
                                    {
                                        toCreateFormData.selectedYear != null ?
                                            (displayForms.length > 0 ?
                                                displayForms.map((form) => {
                                                    return <div onClick={() => handleFormSelect(form)} style={{ ...styles.formBox, ...(toCreateFormData?.selectedForm?.FormId && toCreateFormData.selectedForm.FormId === form.FormId) ? styles.selectedFormBox : "" }} >
                                                        <Heading type={HEADING.H1} customStyle={styles.formNameStyles}>
                                                            {form.FormLabel}
                                                        </Heading>
                                                        <Heading type={HEADING.H3} customStyle={styles.formBoxDesc}>
                                                            {form.Desc}
                                                        </Heading>
                                                        {toCreateFormData?.selectedForm?.FormId && toCreateFormData.selectedForm.FormId === form.FormId &&
                                                            <div style={{ ...styles.nextButtonDiv, ...styles.cardNextBtnDiv }}>
                                                                <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(setIsYearFormTypeSelected(true))}>Next</Button>
                                                            </div>
                                                        }
                                                    </div>
                                                })
                                                : <p>No forms available for the selected year and the searched term</p>)
                                            : <p>Please select year to proceed</p>
                                    }
                                </div>
                                {showFormRecommendation ? <RecommendForms formsList={formsList} userSelectedTaxYear={toCreateFormData.selectedYear} onClickFormFileCb={() => dispatch(setIsYearFormTypeSelected(true))} userSelectedForm={toCreateFormData.selectedForm} handleFormSelectCb={handleFormSelect} onCloseCb={() => setShowFormRecommendation(false)} /> : null}
                            </>
                        }
                        {!isSelect1099Forms && (
                            <>
                                <div>Select Tax Year</div>
                                <div style={styles.yearSelectionRowContainer}>
                                    <div style={styles.yearSelectionRow}>
                                        {
                                            stateNamesList?.Years && stateNamesList.Years.map((formYear) => {
                                                return <div onClick={() => dispatch(setToCreateFormData({ selectedYear: formYear }))} style={{ ...styles.yearBox, ...(toCreateFormData.selectedYear === formYear) ? styles.selectedYearBox : "" }} className={(toCreateFormData.selectedYear === formYear) ? "selectedYearBox" : ""} >
                                                    {formYear}
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                                <div style={styles.yearSelectionRow}>Select State Name</div>
                                <div style={styles.yearSelectionRowContainer}>
                                    <div style={styles.yearSelectionRow}>
                                        <div style={styles.headerRow}>
                                            {stateNamesList?.StateNames && (
                                                <div>
                                                    <SelectDropdown
                                                        name="StateNames"
                                                        placeHolder="Please select a State Name"
                                                        options={stateNamesList?.StateNames && stateNamesList.StateNames.map(state => ({ label: state.trim(), value: state.trim().toLowerCase() }))}
                                                        value={selectedStateName}
                                                        onSelectCb={(name, selectedOption) => {
                                                            handleFormsBtnClick(CREATE_FORM_BUTTONS_FLAGS.FORSTATEPAYROLL_FORMS, false);
                                                            dispatch(setSelectedStateName(selectedOption))

                                                            if (selectedOption?.value) {
                                                                queryParams.set(QUERY_PARAMS.STATENAME, selectedOption?.value)
                                                            } else {
                                                                queryParams.delete(QUERY_PARAMS.STATENAME)
                                                            }
                                                            setQueryParams(queryParams);
                                                        }}
                                                        isClearable={false}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {!isSelect1099Forms &&
                            <>
                                <div style={styles.formSelectionRow}>
                                    {
                                        statePayrollFormsList.map((form) => {
                                            return <div onClick={() => handleStatePayrollFormSelect(form)} style={{ ...styles.formBox, ...(toCreateFormData?.selectedForm?.FormId && toCreateFormData.selectedForm.FormId === form.FormId) ? styles.selectedFormBox : "" }} >
                                                <Heading type={HEADING.H3} customStyle={styles.formNameStyles}>
                                                    {form.FormLabel}
                                                </Heading>
                                                {
                                                    toCreateFormData?.selectedForm?.FormId && toCreateFormData.selectedForm.FormId === form.FormId &&
                                                    <div style={{ ...styles.nextButtonDiv, ...styles.cardNextBtnDiv }}>
                                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(setIsYearFormTypeSelected(true))}>Next</Button>
                                                    </div>
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                            </>
                        }                    
                    </div>
                    <div>
                            <FooterWImageAndActionButtons
                                nextButton={
                                    toCreateFormData.selectedForm ? {
                                        text: "Next",
                                        clickCb: () => { dispatch(setIsYearFormTypeSelected(true)) },
                                    }
                                        : {}
                                }
                            >
                                {
                                    (toCreateFormData?.selectedForm?.FormLabel) ? `Form: ${toCreateFormData.selectedForm.FormLabel} is selected` : null
                                }
                            </FooterWImageAndActionButtons>            
                    </div>
                </div>
            </Loadable>
        }
    </>
}